import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {SkyLayer, skyLayersOptions} from './aladin-sky-layers-options/aladin-sky-layers-options.component';

@Injectable({
  providedIn: 'root'
})
export class AladinSkyLayersService {
  private skyLayers = new BehaviorSubject<SkyLayer[]>(skyLayersOptions.filter(sky => sky.selected));

  private baseSky = new Subject<SkyLayer>();
  private overlaySky = new Subject<SkyLayer>();
  private alpha = new Subject<number>();

  setSkyLayers(skyLayers: SkyLayer[]): void {
    this.skyLayers.next(skyLayers);
  }

  getSkyLayers(): Observable<SkyLayer[]> {
    return this.skyLayers.asObservable();
  }

  getBaseSky(): Observable<SkyLayer> {
    return this.baseSky.asObservable();
  }

  setBaseSky(overlayImage: SkyLayer): void {
    this.baseSky.next(overlayImage);
  }

  getOverlaySky(): Observable<SkyLayer> {
    return this.overlaySky.asObservable();
  }

  setOverlaySky(overlayImage: SkyLayer): void {
    this.overlaySky.next(overlayImage);
  }

  getAlpha(): Observable<number> {
    return this.alpha.asObservable();
  }

  setAlpha(alpha: number): void {
    this.alpha.next(alpha);
  }
}
